//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { mapGetters } from 'vuex'
import { axiosGet, axiosPost } from '../../../../axios/axios.js'
import { convertConfiguredTime, getWorkShiftIconName } from '../../../../components/helpers.js'

import DateField from '../../../../components/Field/DateField.vue'
import BrigadeForkliftTrucksIndicator from '../../../../forms/Brigade/BrigadeForkliftTruck/BrigadeForkliftTrucksIndicator.vue'

export default {
  components: {
    DateField,
    BrigadeForkliftTrucksIndicator,
    BrigadeForkliftTruckFieldTable: () => import('../../../../forms/Brigade/BrigadeForkliftTruck/BrigadeForkliftTruckFieldTable.vue')
  },
  props: {
    opened: {
      type: Boolean,
      default: false
    },
    requestBrigades: {
      type: Array,
      default () {
        return []
      }
    },
    request: {
      type: Object,
      default () {
        return {}
      }
    },
    interval: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data: function () {
    return {
      brigades: [],
      workShift: [],
      workDate: null,
      onlyActiveOrFuture: false,

      selectedBrigades: [],

      loading: false,
      initialized: false
    }
  },
  computed: {
    ...mapGetters({
      getWorkShifts: 'getWorkShifts'
    }),
    workShifts: function () {
      return this.getWorkShifts.filter(ws => ws.active)
    }
  },
  watch: {
    workShift: function (value) {
      if (this.initialized) {
        this.getBrigades()
      }
    },
    onlyActiveOrFuture: function (value) {
      if (this.initialized) {
        this.getBrigades()
      }
    },
    workDate: function (value) {
      if (this.initialized) {
        this.getBrigades()
      }
    }
  },
  created: function () {
    this.setDefaultParameters()
    this.getBrigades()
    this.$nextTick(() => {
      this.initialized = true
    })
  },
  methods: {
    convertTime: function (ms) {
      return convertConfiguredTime(ms, { year: false, month: true, date: true, hour: true, min: true, sec: false })
    },
    containInBrigades: function (brigade, brigades) {
      const brigadeInBrigades = brigades.find(b => b.brigadeId === brigade.id && b.workDate === new Date(brigade.startTime).setHours(0, 0, 0, 0) && b.workShift.key === brigade.workShift)
      return !!brigadeInBrigades
    },
    setDefaultParameters: function () {
      let date = null
      if (this.request.serviceTimeAgreed) {
        date = new Date(this.request.serviceTimeAgreed)
      } else if (this.request.serviceTimeRequired) {
        date = new Date(this.request.serviceTimeRequired)
      } else {
        date = new Date()
      }

      if (date.getHours() < 7) {
        date.setDate(date.getDate() - 1)
        this.workShift = [this.workShifts.find(workShift => workShift.key === 'brigadier.20-32')]
      } else {
        if (date.getHours() < 8) {
          this.workShift = [this.workShifts.find(workShift => workShift.key === 'brigadier.7-19')]
        } else if (date.getHours() < 20) {
          this.workShift = [this.workShifts.find(workShift => workShift.key === 'brigadier.8-20')]
        } else {
          this.workShift = [this.workShifts.find(workShift => workShift.key === 'brigadier.20-32')]
        }
      }

      date.setHours(0, 0, 0, 0)
      this.workDate = date.getTime()
    },
    convertBrigadeProperties: function (brigade) {
      const convertedBrigade = {}
      if (brigade) {
        convertedBrigade.brigadeId = brigade.id
        convertedBrigade.brigadeName = brigade.name
        convertedBrigade.brigadeGUIName = brigade.guiName

        const workShift = this.workShifts.find(w => w.key === brigade.workShift)

        convertedBrigade.workShift = workShift
        convertedBrigade.workShift.endTime = brigade.endTime
        convertedBrigade.workShift.startTime = brigade.startTime

        convertedBrigade.workDate = new Date(brigade.startTime).setHours(0, 0, 0, 0)
        convertedBrigade.workAreas = brigade.workAreas.map(wA => {
          return { name: wA }
        })
      } else {
        convertedBrigade.brigadeId = null
        convertedBrigade.brigadeName = null
        convertedBrigade.brigadeGUIName = null
        convertedBrigade.workShift = null
        convertedBrigade.workDate = null
        convertedBrigade.workAreas = []
      }
      convertedBrigade.assigned = false
      convertedBrigade.nextAssigned = false

      return convertedBrigade
    },
    onSelectBrigadeExact: function (brigade) {
      if (brigade && !this.containInBrigades(brigade, this.requestBrigades)) {
        this.selectedBrigades = []
        this.selectedBrigades.push(this.convertBrigadeProperties(brigade))
      }
    },
    onSelectBrigadeCtrl: function (brigade) {
      if (brigade && this.containInBrigades(brigade, this.requestBrigades)) {
        return
      }
      if (brigade && this.containInBrigades(brigade, this.selectedBrigades)) {
        const index = this.selectedBrigades.indexOf(b => b.id === brigade.id)
        this.selectedBrigades.splice(index, 1, this.convertBrigadeProperties(brigade))
      } else {
        this.selectedBrigades.push(this.convertBrigadeProperties(brigade))
      }
    },
    onSave: function () {
      this.$emit('save', this.selectedBrigades)
    },
    onClose: function () {
      this.$emit('close')
    },
    getBrigades: function () {
      this.loading = true
      this.brigades = []
      this.selectedBrigades = []

      const params = new URLSearchParams()
      params.set('sort', 'name')
      params.set('dir', 'ASC')

      if (this.interval.start) {
        params.set('starttime', this.interval.start)
      }
      if (this.interval.end) {
        params.set('endtime', this.interval.end)
      }
      if (this.workDate) {
        params.set('workDate', this.workDate)
      }
      if (this.workShift && this.workShift.length) {
        params.set('workShift', this.workShift.map(w => w.key).join())
      }
      params.set('onlyActiveOrFuture', this.onlyActiveOrFuture)

      return axiosGet({
        url: '/service/delta/brigade/vehicleProvisionLightSearch?' + params.toString(),
        onSuccess: (response) => {
          const brigades = []
          response.data.forEach(brigade => {
            const workShiftsData = brigade.workShiftsEmployees
            if (!workShiftsData || !workShiftsData.length || brigade.contractor) {
              brigades.push(brigade)
            } else {
              workShiftsData.forEach(workShiftData => {
                const workShiftKey = workShiftData.workShift
                const workDate = new Date(workShiftData.startTime)
                workDate.setHours(0, 0, 0, 0)

                const brigadeOnWorkShift = Object.assign({}, brigade, {
                  workShiftsEmployees: null,
                  workShift: workShiftKey,
                  guiName: brigade.name + '(' + workShiftData.employees.sort((e1, e2) => ((e1.brigadier === e2.brigadier) ? 0 : e1.brigadier ? -1 : 1)).map(employee => employee.fio).join(', ') + ')',
                  workShiftIcon: this.getWorkShiftIconName(workShiftKey),
                  workShiftName: this.workShifts.find(w => w.key === workShiftKey).name,
                  endTime: workShiftData.endTime,
                  startTime: workShiftData.startTime,
                  workDate: workDate.getTime(),
                  date: convertConfiguredTime(workShiftData.startTime, { year: false, month: true, date: true, hour: false, min: false, sec: false })
                })
                brigades.push(brigadeOnWorkShift)
              })
            }
          })

          this.validate(brigades).then(() => {
            this.brigades = brigades
          })
        },
        onFailure: 'Ошибка загрузки бригад'
      }).finally(() => {
        this.loading = false
      })
    },
    validate: function (brigades) {
      if (brigades.length !== 0 && this.interval.start && this.interval.end) {
        const formData = new FormData()
        formData.set('fromTime', this.interval.start)
        formData.set('toTime', this.interval.end)
        formData.set('brigades', JSON.stringify(brigades.map(b => {
          return {
            id: b.id,
            workDate: b.startTime,
            workShift: b.workShift
          }
        })))

        return axiosPost({
          url: '/service/delta/vehicleProvision/validateBrigadesIntervals',
          data: formData,
          onSuccess: (response) => {
            const resultBrigades = response.data.result
            brigades.forEach(b => {
              const resultBrigade = resultBrigades.find(resB => resB.id === b.id && resB.workShift === b.workShift && resB.workDate === this.workDate)
              if (resultBrigade) {
                if (resultBrigade.status !== 'valid') {
                  b._notValid = true
                } else {
                  b._notValid = false
                }
                b.vehicleProvisionRequests = resultBrigade.vehicleProvisionRequests
                b.openedVehicleProvisionRequestsTable = false
              }
            })
          },
          onFailure: 'Ошибка получения валидации бригад'
        })
      } else {
        return Promise.resolve()
      }
    },
    getBrigadeBgColor: function (brigade) {
      if (brigade._notValid) {
        return 'red'
      } else if (this.containInBrigades(brigade, this.selectedBrigades)) {
        return 'blue'
      } else if (this.containInBrigades(brigade, this.requestBrigades)) {
        return 'green'
      } else {
        return 'gray'
      }
    },
    getWorkShiftIconName: function (workShift) {
      if (workShift) {
        const key = workShift.key ? workShift.key : workShift
        return getWorkShiftIconName(key)
      } else {
        return ''
      }
    }
  }
}

